<template>
  <AudienceIntentPage :page="page" />
</template>

<script setup lang="ts">
import { getAudienceSeoPage } from '~/utils/audienceSeoPages'

definePageMeta({
  layout: 'editorial',
  headerOnDark: true,
  nuxtI18n: false
})

const page = getAudienceSeoPage('wholesaleLuxuryHeelsEn')
</script>
